import UserApi from "../store/services/user"


const parseJwt = (token: any) => {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
};

export const API_KEY = "AIzaSyAjlj4SBrMJev8zC95-qsDIo3XZMP10wdY"

export const getToken = () => {
    if (localStorage.getItem("plToken")) {
        const user = JSON.parse(localStorage.getItem("plToken") || "");
        if (user) {
            const decodedJwt = parseJwt(user);
            if (decodedJwt.exp * 1000 < Date.now()) {
                return {}
            }
            else {
                return localStorage.getItem("plToken")
            }
        }
        else {
            return localStorage.getItem("plToken")
        }

    }
    // return localStorage.getItem('plToken')
}
export const removeToken = () => {
    localStorage.removeItem('plToken')
}
export const setToken = (value: any) => {
    localStorage.setItem('plToken', JSON.stringify(value))
}
export const authHeader = () => {
    const user = JSON.parse(localStorage.getItem("plToken") || "")
    if (user) {
        return { authorization: user };
    }
    else {
        return {}
    }
}
export const createNotifictions = (body: any) => {
    UserApi.postNewNotifications(body).then(res => {
    }).catch((e) => {
        if (e.response.status === 403) {
            window.location.href  = "/login"
        }
    })
}